module.exports = __webpack_public_path__ + "static/media/320x100_0009_en.d36aba61.png";